export const INITIALIZE_UBISOFT_CONNECT_DONE = 'INITIALIZE_UBISOFT_CONNECT_DONE';
export const INITIALIZE_UBISOFT_CONNECT_ERROR = 'INITIALIZE_UBISOFT_CONNECT_ERROR';
